import React, { FC, useEffect, useState } from 'react'
import { alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { styled } from '@mui/material/styles'
import SearchIcon from '@mui/icons-material/Search'
import { useSearcherStore } from '../../../hooks/useSearcherStore';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: '10px',
    border: '1px solid #B8B9B8',
    color: '#B8B9B8',
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

interface SearcherProps {
    setShowSearcher: React.Dispatch<React.SetStateAction<boolean>>
}

const Searcher: FC<SearcherProps> = (props): JSX.Element | any => {

    const { setShowSearcher } = props

    const { getSearchProducts, setDataSearch } = useSearcherStore()

    const [search, setSearch] = useState<string>('')

    useEffect(() => {
        if (search !== '') {
            const timer = setTimeout(() => {
                getProducts()
            }, 750)

            return () => clearTimeout(timer)
        }
    }, [search])

    const getProducts = async () => {
        setShowSearcher(true)
        let payload: any = {
            search: search
        }
        const response: any = await getSearchProducts(payload)
        setDataSearch(response.detail || [])
    }

    return (
        <>
            <Search>
                <SearchIconWrapper>
                    <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                    type='text'
                    placeholder="Buscar"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Search>
        </>
    )
}

export default Searcher